import { Avatar } from "@material-ui/core";
import { FormatQuote } from "@material-ui/icons";
import React from "react";

export const Testimonial_Item = ({ pic, name, text }) => {
  return (
    <div className="testimonial-item p-2">
      <div>
        <div className="flex ai-c">
          {typeof pic === null || typeof pic === "undefined" ? (
            <Avatar className="testimonial-avatar" />
          ) : (
            <div className="testimonial-pic-container">
              <img src={pic} alt={name} />
            </div>
          )}
          <h3 className="testimonial-name fw-500 my-2 ml-2">{name}</h3>
        </div>
        <FormatQuote className="quote my-1" />
        <p className="testimonial-text text-black-accent fw-500">{text}</p>
      </div>
    </div>
  );
};
